<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon: settings; ratio:1.2"></span>
            Einstellungen
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <ul uk-tab>
        <li><a href="#">Allgemein</a></li>
        <li><a href="#">Pakete</a></li>
        <!--
        <li><a href="#">Stammdaten</a></li>
        -->
        <li><a href="#">Mailversand</a></li>
      </ul>

      <ul class="uk-switcher uk-margin">
        <li>
          <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
            <div class="uk-card-body">
              <General :config="config" @stored="refreshConfig"></General>
            </div>
          </div>
        </li>
        <li>
          <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
            <div class="uk-card-body">
              <Packages></Packages>
            </div>
          </div>
        </li>
        <!--
        <li>
          <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
            <div class="uk-card-body">
              <div class="uk-grid" data-uk-grid>
                <div class="uk-width-1-2@m">
                  <div class="uk-grid" uk-grid>
                    <div class="uk-width-1-1">
                      <div class="uk-margin">
                        <label class="uk-form-label">Firma</label>
                        <div class="uk-form-controls">
                          <input class="uk-input" name="company" type="text" v-model="tenant.company" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        -->
        <li>
          <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
            <div class="uk-card-body">
              <div class="uk-margin">
                <div class="uk-grid uk-grid-small" data-uk-grid>
                  <div class="uk-width-1-3@m">
                    <div class="uk-margin">
                      <label class="uk-form-label">E-Mail Empfänger für Bestellungen</label>
                      <div class="uk-form-controls">
                        <input
                          class="uk-input"
                          type="text"
                          v-model="config.mailAddresses.saleMail"
                          :disabled="config.saleMailReceiver.receiver === 'editor'"
                        />
                      </div>
                    </div>
                    <div class="uk-margin">
                      <label>
                        <input
                          class="uk-checkbox"
                          type="checkbox"
                          true-value="editor"
                          false-value="default"
                          v-model="config.saleMailReceiver.receiver"
                        />
                        Bestellmail an zugeordneten Verkäufer senden </label
                      ><br />
                      <label>
                        <input class="uk-checkbox" type="checkbox" v-model="config.mail.enable" /> Eigene Daten für
                        Mailversand benutzen
                      </label>
                    </div>
                  </div>
                  <div class="uk-width-1-3@m">
                    <div class="uk-margin">
                      <label class="uk-form-label">Absender E-Mail
                        <span
                          data-uk-icon="icon:question; ratio: 0.7"
                          data-uk-tooltip="Falls abweichend von Profil E-Mail"
                          style="display: inline-flex;"
                        ></span
                      ></label>
                      <div class="uk-form-controls">
                        <input
                          class="uk-input"
                          type="text"
                          v-model="config.mailAddresses.mailFrom"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                <div class="uk-grid uk-grid-small" data-uk-grid>
                  <div class="uk-width-1-3@m">
                    <div class="uk-grid" uk-grid v-if="config.mail.enable">
                      <div class="uk-width-1-1">
                        <div class="uk-margin">
                          <label class="uk-form-label uk-flex uk-flex-top"
                            >SMTP Server*
                            <span
                              data-uk-icon="icon:question; ratio: 0.7"
                              data-uk-tooltip="Der Hostname des SMTP-Servers."
                              class="uk-margin-small-left"
                            ></span
                          ></label>
                          <div class="uk-form-controls">
                            <ValidationProvider :rules="'required'" name="smtp" v-slot="{ errors }">
                              <input
                                class="uk-input"
                                type="text"
                                v-model="config.mail.smtp"
                                :class="{ 'uk-form-danger': errors[0] }"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label uk-flex uk-flex-top"
                            >Benutzer*<span
                              data-uk-icon="icon:question; ratio: 0.7"
                              data-uk-tooltip="Benutzernamen für den SMTP-Host eingeben. Entspricht meistens der E-Mail Adresse"
                              class="uk-margin-small-left"
                            ></span
                          ></label>
                          <div class="uk-form-controls">
                            <ValidationProvider :rules="'required'" name="username" v-slot="{ errors }">
                              <input
                                class="uk-input"
                                type="text"
                                v-model="config.mail.username"
                                :class="{ 'uk-form-danger': errors[0] }"
                              />
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="uk-margin">
                          <label class="uk-form-label uk-flex uk-flex-top"
                            >Passwort*<span
                              data-uk-icon="icon:question; ratio: 0.7"
                              data-uk-tooltip="Passwort für den SMTP-Host eingeben."
                              class="uk-margin-small-left"
                            ></span
                          ></label>
                          <div class="uk-form-controls">
                            <ValidationProvider :rules="'required'" name="password" v-slot="{ errors }">
                              <input
                                class="uk-input"
                                type="password"
                                v-model="config.mail.password"
                                :class="{ 'uk-form-danger': errors[0] }"
                              />
                            </ValidationProvider>
                          </div>
                          <div class="uk-margin">
                            <div class="uk-position-relative">
                              <div class="uk-position-absolute">
                                <label class="uk-form-label uk-flex uk-flex-top"
                                  >Port*
                                  <span data-uk-icon="icon:question; ratio: 0.7" class="uk-margin-small-left"></span>
                                </label>
                                <div uk-drop="pos: right;delay-hide:0">
                                  <div class="uk-card uk-card-body uk-card-default uk-padding-small uk-text-small">
                                    Portnummer des SMTP-Servers zum Versenden von E-Mails eingeben.<br /><br />Standardports:
                                    <ul class="uk-list">
                                      <li><strong>25:</strong> Bei ungesicherten E-Mail-Servern.</li>
                                      <li><strong>465:</strong> Bei einem gesicherten E-Mail-Server mit SMTPS.</li>
                                      <li>
                                        <strong>25 oder 587:</strong> Bei einem gesicherten E-Mail-Server mit
                                        STARTTLS-Erweiterung.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <ValidationProvider :rules="'required'" name="port" v-slot="{ errors }">
                                <input
                                  type="text"
                                  class="uk-input uk-margin-top"
                                  v-model="config.mail.port"
                                  :class="{ 'uk-form-danger': errors[0] }"
                                />
                              </ValidationProvider>
                            </div>
                          </div>
                          <div class="uk-margin">
                            <div class="uk-position-relative">
                              <div class="uk-position-absolute">
                                <label class="uk-form-label uk-flex uk-flex-top"
                                  >SMTP-Sicherheit*
                                  <span data-uk-icon="icon:question; ratio: 0.7" class="uk-margin-small-left"></span>
                                </label>
                                <div uk-drop="pos: right;delay-hide:0">
                                  <div class="uk-card uk-card-body uk-card-default uk-padding-small uk-text-small">
                                    Das vom SMTP-Server genutzte Sicherheitsmodul zum Versenden von E-Mails eingeben.<br />
                                    <ul class="uk-list">
                                      <li><strong>Keine:</strong> Keine Verschlüsselung</li>
                                      <li><strong>SSL/TLS:</strong> Nutzt SMTPS (normalerweise auf Port 465)</li>
                                      <li>
                                        <strong>STARTTLS:</strong> Nutzt STARTTLS für SMTP (normalerweise auf Port 25
                                        oder 587)
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <select class="uk-select uk-margin-top" v-model="config.mail.security">
                                <option value="">Keine</option>
                                <option value="ssl">SSL/TLS</option>
                                <option value="tls">STARTTLS</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="uk-width-1-1">
                    <div class="uk-align-left">
                      <button
                        type="submit"
                        class="uk-button uk-button-primary"
                        @click.prevent="handleSubmit(store)"
                        :disabled="submitting"
                      >
                        Speichern
                      </button>
                    </div>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import ConfigService from '@/services/config.service'
import Packages from '@/components/admin/Packages'
import General from '@/components/admin/GeneralSettings'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { map } from 'lodash'
import { mapActions } from 'vuex'

extend('required', {
  ...required,
  message: 'Pflichtfeld'
})

export default {
  data() {
    return {
      sales: [],
      loading: true,
      submitting: false,
      config: {
        general: {
          disableCart: false
        },
        tenant: {},
        mailAddresses: {
          saleMail: '',
          mailFrom: ''
        },
        saleMailReceiver: {
          receiver: 'default'
        },
        mail: {
          enable: false,
          smtp: '',
          username: '',
          password: '',
          port: '',
          security: ''
        }
      }
    }
  },
  components: { Packages, General, ValidationProvider, ValidationObserver },
  mounted() {
    this.getConfig()
  },
  methods: {
    ...mapActions({
      refreshConfig: 'getConfig'
    }),
    async getConfig() {
      const config = await ConfigService.get()
      map(config.data, c => {
        this.config[c.configKey] = c.configValue
      })
    },
    async store() {
      this.submitting = true
      await ConfigService.store(this.config)
      this.submitting = false
      iziToast.success({
        title: 'OK',
        message: 'Einstellungen gespeichert!',
        timeout: 3000,
        position: 'topCenter'
      })
    }
  }
}
</script>
